module.exports = __webpack_public_path__ + "img/Angiogenesis-NPC_GSE200310.9ca93f95.png";